// ============================================================================
// UKRAINIAN TRANSLATIONS - CHAPTER 8: ДОПОМОГА ВСЕВИШНЬОГО (БОНУС)
// ============================================================================
// Рівень 92 (1 бонусний рівень, 3 питання)

export const chapter8Translations = {
  name: "Допомога Всевишнього",
  description: "Хто живе під покровом Всевишнього, під тінню Всемогутнього спочиває",
  
  spiritualWisdom: {
    principle: "Ви досягли вершини гори, і знання здобуто",
    scripture: "Хто живе під покровом Всевишнього, під тінню Всемогутнього спочиває (Псалом 90:1)",
    application: "Непохитна віра вимагає життєвого досвіду, милосердя та справжньої любові Ісуса. Випробування перевірять ваше серце, справжній обраний шлях."
  },
  
  levels: {
    92: {
      name: "Покров Всевишнього",
      challenge: "Ви на вершині гори... Але непохитна віра починається зараз...",
      easy: {
        question: "Хто такий Ісус для вас особисто?",
        options: [
          "Простий пророк",
          "Мій особистий Господь і Спаситель",
          "Легенда",
          "Філософ"
        ],
        hint: "Він Той, Хто віддає Своє життя, щоб врятувати нас",
        funFact: "✝️ Ісус - це Бог! Він не просто історична постать - Він живий і бажає особистих стосунків з кожним із нас!"
      },
      medium: {
        question: "Чому піст, як у Даниїла, дозволяє нам краще чути Бога?",
        options: [
          "Щоб схуднути",
          "Щоб позбавити себе того, що ми любимо, і мати перетворене серце",
          "Щоб справити враження на інших",
          "Щоб бути сильнішим"
        ],
        hint: "Позбавте себе того, що ви любите найбільше, у тиші та мудрості",
        funFact: "🙏 Духовний піст готує наше серце до глибоких перетворень - часто болючих - які наближають нас до Бога!"
      },
      hard: {
        question: "Яка справжня відповідь серця на все це здобуте знання?",
        options: [
          "Тепер я досконалий",
          "Я віддаю Тобі своє серце, Ісусе, і бажаю охреститися",
          "Я знаю краще за інших",
          "Мені більше не потрібна допомога"
        ],
        hint: "Справжня віра веде до повної віддачі та посвячення Ісусу",
        funFact: "🌟✨ Ви досягли вершини гори, і знання здобуто ✨\n\n💖 Непохитна віра вимагає життєвого досвіду, милосердя та справжньої любові Ісуса 💖\n\n🔥 Різні випробування життя перевірять ваш шлях, справжню дорогу, яку ми обираємо, наше серце 🔥\n\n😔 Ми залишаємося недосконалими, наші бажання численні, і любов до наживи або до нашого особистого комфорту надто часто стає нашим егоїстичним пріоритетом 😔\n\n🙏 Просіть у Бога мудрості, Його любові, Його сили і смиренно визнавайте свої слабкості, бо ми не можемо приховати від Нього нічого... Нічого 🙏\n\n🥖 Постіть, як Даниїл: позбавте себе на час того, що ви любите найбільше, у тиші та мудрості 🥖\n\n💫 Це дозволить вам краще чути Бога, мати готовність серця до глибоких перетворень 💫\n\n🌙 Тоді сни та видіння стануть яснішими, як у Йосипа 🌙\n\n⚠️ Остерігайтеся гордині: не піддавайтеся на 'я завжди правий' або 'я знаю краще' ⚠️\n\n🎁 Бо одкровення Боже - це надзвичайна благодать 🎁\n\n💝 Мати віру - означає увійти у стосунки та вільний шлях серця 💝\n\n🦸‍♂️ Це зробить вас могутніми героями, здатними на неможливе 🦸‍♂️\n\n✝️ На вершині знання щире серце каже: 'Я віддаю Тобі своє серце, Ісусе, і бажаю охреститися' ✝️\n\n🏔️ Ви досягли вершини гори, тримайтеся міцніше, проявіть наполегливість! 🏔️\n\n⬇️ Треба спуститися і нести цей дорогоцінний скарб: надію на вічне життя ⬇️\n\n🏆✨ БРАВО! МИ ПИШАЄМОСЯ ТОБОЮ ✨🏆\n🌟 МУЖНІСТЬ ДОБЛЕСНИЙ МИРОТВОРЕЦЬ 🌟\n🕊️✨ НЕХАЙ БОГ БЛАГОСЛОВИТЬ ТЕБЕ ✨🕊️"
      }
    }
  }
};

export default chapter8Translations;
